<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                this.$l('form_reportorderlist_search') ||
                '业务人员名称/客户名称 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              variant="outline-success"
              class="ml-2"
              @click="exportVisible = true"
            >
              <i class="el-icon-folder-opened"></i>
              {{ $l('INDEX.btn_export') || '导出' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      v-if="exportVisible"
      show-close
      :visible.sync="exportVisible"
      width="570px"
      :title="$l('dialog_title_export_order_details_report') || '导出方式选择'"
      :close-on-click-modal="false"
      :before-close="() => (exportVisible = false)"
      destroy-on-close
      append-to-body
      v-el-dialog-drag
    >
      <div class="print_btn_group">
        <div style="cursor: pointer" @click="exportExcel(false)">
          <div class="print_btn" style="background-color: #f8f8f9">
            <div class="text_flag">
              {{ $l('dialog_title_do_not_use_image') || '无图片方式导出' }}
            </div>
          </div>
          <div class="text_bottom mt-2">
            {{
              $l('dialog_title_choose_do_not_use_image') || '选择无图片方式导出'
            }}
          </div>
        </div>

        <div style="cursor: pointer" @click="exportExcel(true)">
          <div class="print_btn">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 155px; height: 110px"
            />
          </div>
          <div class="text_bottom mt-2">
            {{ $l('dialog_title_choose_use_image') || '选择带图片方式导出' }}
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="135px"
        size="mini"
        label-position="right"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_salesPersonName') || '业务人员'"
            >
              <dict-select
                clearable
                v-model="form.salesPersonCode"
                filterable
                size="mini"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                :selectedLabel.sync="form.salesPersonName"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_bizPersonName') || '跟单人员'"
            >
              <dict-select
                clearable
                v-model="form.bizPersonCode"
                filterable
                size="mini"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                :selectedLabel.sync="form.bizPersonName"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_custName') || '客户名称'">
              <dict-select
                size="mini"
                clearable
                v-model="form.custCode"
                filterable
                url="/master/common/dict/customerSelect"
                style="width: 100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('table_label_endCustName') || '终端客户'">
              <dict-select
                size="mini"
                clearable
                v-model="form.endCustCode"
                filterable
                url="/master/common/dict/customerSelect"
                style="width: 100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_orderNo') || '订单编号'">
              <el-input
                size="mini"
                clearable
                v-model.trim="form.orderNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_custOrderNo') || '客户订单编号'"
            >
              <el-input
                v-model.trim="form.custOrderNo"
                clearable
                size="mini"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('table_label_retailerPo') || '零售商PO'">
              <el-input
                v-model.trim="form.retailerPo"
                clearable
                size="mini"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('table_label_importerPo') || '代理商PO'">
              <el-input
                v-model.trim="form.importerPo"
                clearable
                size="mini"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_brandName') || '品牌名称'">
              <dict-select
                size="mini"
                clearable
                v-model="form.brandCode"
                filterable
                url="/master/common/dict/brandSelect"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                style="width: 100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_masterCategoryName') || '产品主分类'"
            >
              <dict-select
                :placeholder="$l('INDEX.tips_select_data') || '请选择'"
                size="small"
                clearable
                filterable
                v-model="form.masterCategoryCode"
                :body="{ parentCode: 'ABSHome' }"
                url="/master/masterCategory/select"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_orderGoodsName') || '产品中文名称'"
            >
              <el-input
                v-model.trim="form.orderGoodsName"
                clearable
                size="mini"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_orderGoodsNameEn') || '产品英文名称'"
            >
              <el-input
                v-model.trim="form.orderGoodsNameEn"
                clearable
                size="mini"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_scmName') || '执行工厂'">
              <dict-select
                size="mini"
                clearable
                filterable
                v-model="form.scmCode"
                :body="{}"
                url="/master/common/dict/scmPartners"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('table_label_orderScmName') || '名义工厂'">
              <dict-select
                size="mini"
                clearable
                filterable
                v-model="form.orderScmCode"
                :body="{}"
                url="/master/common/dict/scmPartners"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('table_label_issueDate') || '客户下单时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginIssueDate"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endIssueDate"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('table_label_deliveryDay') || '交货日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginDeliveryDay"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endDeliveryDay"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item>
                <template slot="label">
                  <div>
                    <span
                      >{{
                        $l('table_label_comprehensive_delivery_time') ||
                        '综合交期'
                      }}
                    </span>
                    <el-popover
                      placement="top"
                      width="300"
                      trigger="hover"
                      :content="
                        $l('tips_comprehensive_delivery_time') ||
                        '根据客户下单时间或者SW start查询'
                      "
                    >
                      <i
                        class="el-icon-warning-outline"
                        style="color: #6f6ff8"
                        slot="reference"
                      ></i>
                    </el-popover>
                  </div>
                </template>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginComprehensiveDeliveryDay"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endComprehensiveDeliveryDay"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginModifyTime"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endModifyTime"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_hasShipping') || '是否已出运'">
              <el-radio-group v-model="form.hasShipping">
                <el-radio label="Y">{{ $l('INDEX.YES') || '是' }} </el-radio>
                <el-radio label="N">{{ $l('INDEX.NO') || '否' }} </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('form_label_actualETD') || '实际发运日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.actualETDStart"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.actualETDEnd"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
const initForm = { keyword: '', beginDeliveryDay: '', endDeliveryDay: '' }
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  data() {
    return {
      advqueryDialogVisible: false,
      exportVisible: false,
      form: { ...initForm },
      deliveryDayRange: 6,
    }
  },
  async mounted() {
    const res = await this.$api
      .SYS_PARAMS_DETAIL({ paramID: 'ReportOrderListDeliveryDayRange' })
      .catch(() => null)
    const { paramValue } = res?.body || 6
    this.deliveryDayRange = parseInt(paramValue) || 6

    this.form.beginDeliveryDay = dayjs()
      .subtract(this.deliveryDayRange, 'month')
      .format('YYYY-MM-DD')
    this.form.endDeliveryDay = dayjs().format('YYYY-MM-DD')
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
      this.form.beginDeliveryDay = dayjs()
        .subtract(this.deliveryDayRange, 'month')
        .format('YYYY-MM-DD')
      this.form.endDeliveryDay = dayjs().format('YYYY-MM-DD')
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    exportExcel(useImage) {
      const taskName = `factory-report-order-list`
      this.addExportTask(taskName, useImage)
    },
    addExportTask(taskName, useImage) {
      this.loadingOpen()
      this.$api
        .SYS_EXPORT_TASK(taskName, { ...this.form, useImage })
        .then((res) => {
          this.loadingClose()
          const { status } = res || {}
          if (200 === status) {
            this.$message({
              message:
                this.$l('INDEX.added_to_the_download_center') ||
                '导出任务已经添加到下载中心，请稍后从下载中心下载文件',
              type: 'success',
            })
            this.exportVisible = false
            return
          } else {
            this.$message.error(
              this.$l('INDEX.Description_Failed_to_add_export_task') ||
                '导出任务添加失败'
            )
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(
            this.$l('INDEX.Description_Failed_to_add_export_task') ||
              '导出任务添加失败'
          )
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
.print_btn_group {
  height: 230px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-bottom: 10px;

  .print_btn {
    width: 170px;
    height: 130px;
    border: #bbbbbb 1px solid;
    border-radius: 5px;
    padding: 5px;
    .text_flag {
      text-align: center;
      font-weight: 800;
      line-height: 110px;
      font-size: 15px;
      color: #101010;
    }
  }
  .text_bottom {
    text-align: center;
    color: #007bff;
    font-weight: 550;
  }
}
</style>
